/* YYorrZ Product Salon — gallery, viewer, variant sync, mobile purchase dock */
(function(){
  'use strict';

  function imageKey(url){
    if(!url)return '';
    try{
      var parsed=new URL(url,window.location.href);
      return parsed.pathname.replace(/_(\d+x\d+|\d+x|x\d+)(?=\.[^.]+$)/,'');
    }catch(e){return String(url).split('?')[0];}
  }

  function enhanceSalonGallery(section){
    var gallery=section.querySelector('[data-product-gallery]');
    var hero=section.querySelector('[data-product-main-image]');
    if(!gallery||!hero)return;

    var thumbs=Array.prototype.slice.call(section.querySelectorAll('[data-salon-thumb]'));
    var stage=section.querySelector('[data-salon-stage]');
    var openButton=section.querySelector('[data-salon-open]');
    var currentLabel=section.querySelector('[data-salon-current]');
    var totalLabel=section.querySelector('[data-salon-total]');
    var prev=section.querySelector('[data-salon-prev]');
    var next=section.querySelector('[data-salon-next]');
    var viewer=section.querySelector('[data-salon-viewer]');
    var viewerImage=section.querySelector('[data-salon-viewer-image]');
    var viewerCurrent=section.querySelector('[data-salon-viewer-current]');
    var viewerClose=section.querySelector('[data-salon-viewer-close]');
    var viewerPrev=section.querySelector('[data-salon-viewer-prev]');
    var viewerNext=section.querySelector('[data-salon-viewer-next]');
    var activeIndex=0;
    var lastFocus=null;

    /* The full product-image canvas uses the YYorrZ blue-grey surface. */
    section.style.setProperty('--pdp-image-bg','#C5CBE3');

    if(totalLabel)totalLabel.textContent=String(thumbs.length||1);

    function indexFromHero(){
      var key=imageKey(hero.getAttribute('src'));
      var found=thumbs.findIndex(function(thumb){return imageKey(thumb.getAttribute('data-image-src'))===key;});
      return found>=0?found:activeIndex;
    }

    function sync(index){
      if(!thumbs.length)return;
      index=Math.max(0,Math.min(index,thumbs.length-1));
      activeIndex=index;
      thumbs.forEach(function(thumb,i){
        var selected=i===index;
        thumb.classList.toggle('is-selected',selected);
        thumb.setAttribute('aria-pressed',selected?'true':'false');
      });
      if(currentLabel)currentLabel.textContent=String(index+1);
      if(viewerCurrent)viewerCurrent.textContent=String(index+1);
      if(viewer&&!viewer.hidden&&viewerImage){
        viewerImage.src=hero.currentSrc||hero.src;
        viewerImage.alt=hero.alt||'';
      }
    }

    function revealHero(){
      if(!stage)return;
      var header=document.querySelector('.site-header');
      var headerHeight=header?Math.max(0,header.getBoundingClientRect().height):0;
      var scrollTop=window.pageYOffset||document.documentElement.scrollTop||0;
      var top=stage.getBoundingClientRect().top+scrollTop-headerHeight;
      window.scrollTo(0,Math.max(0,top));
    }

    function show(index,reveal){
      if(!thumbs.length)return;
      if(index<0)index=thumbs.length-1;
      if(index>=thumbs.length)index=0;
      var thumb=thumbs[index];
      var src=thumb.getAttribute('data-image-src');
      var alt=thumb.getAttribute('data-image-alt')||'';
      if(src){
        hero.src=src;
        hero.removeAttribute('srcset');
        hero.alt=alt;
      }
      sync(index);
      if(reveal)window.requestAnimationFrame(revealHero);
    }

    /* Lower-image selection deliberately returns the shopper to the hero. */
    thumbs.forEach(function(thumb,index){
      thumb.addEventListener('click',function(event){
        event.preventDefault();
        show(index,true);
      });
    });

    /* Hero arrows change only the image; they never move the page. */
    if(prev)prev.addEventListener('click',function(event){event.preventDefault();show(activeIndex-1,false);});
    if(next)next.addEventListener('click',function(event){event.preventDefault();show(activeIndex+1,false);});

    /* Variant-driven image changes update selected state without scrolling to a lower tile. */
    var srcObserver=new MutationObserver(function(){sync(indexFromHero());});
    srcObserver.observe(hero,{attributes:true,attributeFilter:['src']});
    sync(indexFromHero());

    var startX=null,startY=null;
    if(stage){
      stage.addEventListener('pointerdown',function(event){
        if(event.pointerType==='mouse')return;
        startX=event.clientX;startY=event.clientY;
      },{passive:true});
      stage.addEventListener('pointerup',function(event){
        if(startX===null||startY===null)return;
        var dx=event.clientX-startX,dy=event.clientY-startY;
        startX=null;startY=null;
        if(Math.abs(dx)>48&&Math.abs(dx)>Math.abs(dy)*1.15){
          if(dx<0)show(activeIndex+1,false);else show(activeIndex-1,false);
        }
      },{passive:true});
    }

    function openViewer(){
      if(!viewer||!viewerImage)return;
      lastFocus=document.activeElement;
      viewerImage.src=hero.currentSrc||hero.src;
      viewerImage.alt=hero.alt||'';
      viewer.hidden=false;
      document.body.classList.add('yyz-product-viewer-open');
      sync(activeIndex);
      if(viewerClose)viewerClose.focus();
    }
    function closeViewer(){
      if(!viewer)return;
      viewer.hidden=true;
      document.body.classList.remove('yyz-product-viewer-open');
      if(lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus();
    }
    if(openButton)openButton.addEventListener('click',openViewer);
    if(viewerClose)viewerClose.addEventListener('click',closeViewer);
    if(viewerPrev)viewerPrev.addEventListener('click',function(event){event.preventDefault();show(activeIndex-1,false);});
    if(viewerNext)viewerNext.addEventListener('click',function(event){event.preventDefault();show(activeIndex+1,false);});
    if(viewer)viewer.addEventListener('click',function(event){if(event.target===viewer)closeViewer();});
    document.addEventListener('keydown',function(event){
      if(!viewer||viewer.hidden)return;
      if(event.key==='Escape'){event.preventDefault();closeViewer();}
      else if(event.key==='ArrowLeft'){event.preventDefault();show(activeIndex-1,false);}
      else if(event.key==='ArrowRight'){event.preventDefault();show(activeIndex+1,false);}
    });
  }

  function enhancePurchaseState(section){
    var idInput=section.querySelector('[data-product-id-input]');
    var availability=section.querySelector('[data-product-availability]');
    var add=section.querySelector('[data-add-to-cart]');
    function updateAvailability(){
      if(!availability||!add)return;
      availability.textContent=add.disabled?'Currently unavailable':'Ready to bag';
    }
    if(add){new MutationObserver(updateAvailability).observe(add,{attributes:true,attributeFilter:['disabled']});updateAvailability();}
    section.addEventListener('change',function(event){
      if(!event.target||!event.target.matches('[data-variant-option]'))return;
      window.requestAnimationFrame(function(){
        if(idInput)idInput.dispatchEvent(new Event('change',{bubbles:true}));
        updateAvailability();
      });
    });
  }

  function enhanceMobileDock(section){
    if(section.querySelector('[data-yyz-mobile-dock]'))return;
    var formWrap=section.querySelector('[data-product-form]');
    var add=formWrap&&formWrap.querySelector('[data-add-to-cart]');
    if(!formWrap||!add)return;
    var title=section.querySelector('.product-title');
    var price=section.querySelector('[data-product-price]');
    var dock=document.createElement('div');
    dock.className='yyz-mobile-dock';
    dock.setAttribute('data-yyz-mobile-dock','');
    dock.setAttribute('aria-label','Quick add to bag');
    dock.innerHTML='<div class="yyz-mobile-dock__summary"><span class="yyz-mobile-dock__ready">READY TO BAG</span><span class="yyz-mobile-dock__title"></span></div><button type="button" class="yyz-mobile-dock__button"><span>ADD TO BAG</span><strong></strong></button>';
    document.body.appendChild(dock);
    var dockTitle=dock.querySelector('.yyz-mobile-dock__title');
    var dockPrice=dock.querySelector('strong');
    var dockButton=dock.querySelector('.yyz-mobile-dock__button');
    function sync(){
      dockTitle.textContent=title?title.textContent.trim():'';
      dockPrice.textContent=price?price.textContent.trim():'';
      dockButton.disabled=add.disabled;
      dock.classList.toggle('is-sold-out',add.disabled);
    }
    dockButton.addEventListener('click',function(){if(!add.disabled)add.click();});
    if(price)new MutationObserver(sync).observe(price,{childList:true,subtree:true,characterData:true});
    new MutationObserver(sync).observe(add,{attributes:true,attributeFilter:['disabled']});
    sync();
    function position(){
      var compact=window.innerWidth<=640;
      dock.hidden=!compact;
      dock.classList.toggle('is-cookie-visible',document.documentElement.classList.contains('yyz-cookie-visible'));
    }
    position();
    window.addEventListener('resize',position,{passive:true});
    new MutationObserver(position).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  }

  function enhanceSection(section){
    if(!section||section.dataset.yyzSalonReady==='true')return;
    section.dataset.yyzSalonReady='true';
    enhanceSalonGallery(section);
    enhancePurchaseState(section);
    enhanceMobileDock(section);
  }
  function init(root){
    var scope=root||document;
    if(scope.matches&&scope.matches('[data-product-section]'))enhanceSection(scope);
    if(scope.querySelectorAll)scope.querySelectorAll('[data-product-section]').forEach(enhanceSection);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
